import EventEmitter from 'eventemitter3';

export interface OptionsProps {
  emitter: EventEmitter;
}

export enum SPEED_OPTION {
  STANDARD = 'STANDARD',
  FAST_TRACK ='FAST_TRACK',
}
